class DrawerAccounts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const clieckedTriggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.type !== clieckedTriggerEl.dataset.type,
      )
    })

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.type === clieckedTriggerEl.dataset.type,
      )
    })
  }
}

if (!customElements.get('drawer-accounts')) {
  customElements.define('drawer-accounts', DrawerAccounts)
}
